'use client'

import { Image } from '@vinted/web-ui'

import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import { ValuePropositionCardModel } from './types'
import { IMAGE_BASE_URL } from '../../constants'

const Card = ({ imageFileName, title, description, testId }: ValuePropositionCardModel) => {
  const translate = useTranslate('business.pro_integrations.value_proposition')
  const imageUrl = `${IMAGE_BASE_URL}/${imageFileName}`

  return (
    <article className="pro-integrations__value-proposition-card" data-testid={testId}>
      <div className="pro-integrations__value-proposition-card-image">
        <Image
          src={`${imageUrl}.png`}
          srcset={`${imageUrl}.png 200w, ${imageUrl}@2x.png 400w`}
          sizes="200px"
          scaling={Image.Scaling.Cover}
          loading="lazy"
        />
      </div>
      <h3
        className="pro-integrations__value-proposition-card-title"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: translate(title) }}
      />
      <p
        className="pro-integrations__value-proposition-card-description"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: translate(description) }}
      />
    </article>
  )
}

export default Card
